export type HomeThemeId = "day" | "night";

export type HomeTheme = {
  id: HomeThemeId;
  nameTh: string;
  hintTh: string;
  /** Vertical sky gradient (Phaser 0xRRGGBB). */
  gradientTop: number;
  gradientBottom: number;
  /** Soft mid band overlay. */
  gradientMid: number;
  midAlpha: number;
  /** World veil alpha over gradient. */
  dimAlpha: number;
  /** Play-grid fill tint when no floor skin. */
  floorTint: number;
};

/** Built-in light packs — gradients only, no scene images. */
export const HOME_THEMES: HomeTheme[] = [
  {
    id: "day",
    nameTh: "กลางวัน",
    hintTh: "ฟ้าสว่าง · โทนเย็น",
    gradientTop: 0x8ec8f0,
    gradientBottom: 0xd8e6f2,
    gradientMid: 0xfff0c8,
    midAlpha: 0.22,
    dimAlpha: 0.06,
    floorTint: 0xc5d4e4,
  },
  {
    id: "night",
    nameTh: "กลางคืน",
    hintTh: "ฟ้ามืด · โทนเย็นลึก",
    gradientTop: 0x0b1224,
    gradientBottom: 0x1a2744,
    gradientMid: 0x3a5080,
    midAlpha: 0.28,
    dimAlpha: 0.2,
    floorTint: 0x1e2836,
  },
];

const LEGACY_THEME_IDS: Record<string, HomeThemeId> = {
  default: "day",
  dusk: "night",
  mist: "day",
  ambient: "day",
};

export function themeById(id: string | null | undefined): HomeTheme {
  if (id && (id === "day" || id === "night")) {
    return HOME_THEMES.find((t) => t.id === id) ?? HOME_THEMES[0]!;
  }
  const mapped = id ? LEGACY_THEME_IDS[id] : undefined;
  return HOME_THEMES.find((t) => t.id === mapped) ?? HOME_THEMES[0]!;
}
